/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text } from '@components/atoms'
import { Footer } from '@components/systems'

import { useAppSelector, PaymentStateType } from '@redux/index'
import { grey } from '@mui/material/colors'

const PaymentSuccess = () => {
	const successMessage: PaymentStateType['paymentSuccess'] = useAppSelector(
		state => state.payment.paymentSuccess,
	)
	return (
		<View css={style}>
			<View className="outerView">
				<View className="contentOuterView">
					<Text category="h1">Thank you!</Text>

					<View className="contentView">
						<Text category="h2">Your order has been successfully placed.</Text>
						<Text category="h1" style={{ fontSize: '100px', lineHeight: '0.5' }}>
							🎉
						</Text>

						<View className="emailNotificationView">
							<Text className="emailNotification" category="h6">
								An email containing detailed order information has been sent to your
								registered address.
							</Text>
							<Text className="emailNotification" category="h6">
								Kindly check your inbox for confirmation.
							</Text>
						</View>

						<View className="orderView">
							<Text className="orderLabel" category="p2">
								Order No.
							</Text>
							<Text className="orderData" category="h6">
								{successMessage.orderId}
							</Text>
						</View>

						<View className="orderView">
							<Text className="orderLabel" category="p2">
								Order Detail
							</Text>
							<Text className="orderData" category="h6">
								{successMessage.orderDetail}
							</Text>
						</View>

						<View className="orderView">
							<Text className="orderLabel" category="p2">
								Your Address
							</Text>
							<Text className="orderData" category="h6">
								{successMessage.address}
							</Text>
						</View>

						<View className="orderView">
							<Text className="orderLabel" category="p2">
								Email
							</Text>
							<Text className="orderData" category="h6">
								{successMessage.email}
							</Text>
						</View>

						<View className="orderView">
							<Text className="orderLabel" category="p2">
								Phone Number
							</Text>
							<Text className="orderData" category="h6">
								{successMessage.phoneNumber}
							</Text>
						</View>
					</View>
				</View>
			</View>

			<Footer />
		</View>
	)
}

export default PaymentSuccess

const style = css({
	position: 'relative',
	width: '100%',

	'.outerView': {
		display: 'flex',
		paddingTop: '2rem',
		paddingBottom: '2rem',
		borderBottom: '1px solid',
		borderColor: grey[300],

		'.contentOuterView': {
			width: '100%',
			padding: '2rem',

			'.contentView': {
				width: '100%',
				maxWidth: '60rem',
				minHeight: '26rem',
				margin: 'auto',
				borderTop: '1px solid',
				borderColor: grey[500],

				'.orderView': {
					display: 'flex',
					alignItems: 'center',
					width: '30rem',
					margin: 'auto',

					'.orderLabel': {
						width: '10rem',
						textAlign: 'left',
					},
					'.orderData': {
						textAlign: 'left',
					},
				},

				'.emailNotificationView': {
					marginTop: '5rem',
					marginBottom: '5rem',
					wordBreak: 'keep-all',
				},
			},
		},
	},

	'@media (max-width: 600px)': {
		'.outerView': {
			'.contentOuterView': {
				'.contentView': {
					'.orderView': {
						display: 'block',
						width: '100%',
						marginBottom: '2rem',
						borderBottom: '1px solid',
						borderColor: grey[300],

						'.orderData': {
							// fontSize: '13px',
						},
					},
				},
			},
		},
	},
})
